import PropTypes from "prop-types";
import typedAction from "data/util/typedAction";

const DefineActions = {
    // these are dispatched by the define function for scraping
    CHOICE: typedAction("global-define/choice", {
        key: PropTypes.string.isRequired,
        def: PropTypes.shape({
            key: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    name: PropTypes.string.isRequired, // the human name, NOT the script one!
                    label: PropTypes.string, // missing implies "use name"
                    atomic: PropTypes.bool, // missing implies "false"
                }),
            ).isRequired
        }).isRequired,
    }),
    ENTITY: "global-define/entity",
    TABLE: "global-define/table",
    MAPPING: "global-define/mapping",
    STEREOTYPE: "global-define/stereotype",
    SYNTHETIC_STEREOTYPE: "global-define/synthetic-stereotype",

    // this is dispatched by the _unload function used in tests
    _UNLOAD: "global-define/_unload",
};

export default DefineActions;



// WEBPACK FOOTER //
// ./app/jsmodel/DefineActions.js